import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, Modal, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { getAssociates, getBoxWorkType, getOnlyOrgForm as getEmployees } from 'app/entities/common/common.reducer';
import { getEntities as getFields } from 'app/entities/field/field.reducer';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import { getEntities as getProjects } from 'app/entities/project/project.reducer';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import { Container } from 'reactstrap';
import { createEntity, createEntityWithOpenModalKr, getEntity, updateEntity } from '../objective.reducer';
import ObjectiveKRRowSelection from './view-row-selection/objective-kr';

type FormObjectiveType = {
  isOpen: boolean;
  onClose: (isReload?: boolean, id?: string) => void;
  id?: string;
};

export const ObjectiveUpdate = ({ isOpen, onClose, id }: FormObjectiveType) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const isNew = id === undefined || id === null;

  const objectiveEntity = useAppSelector(state => state.objective.entity);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const projectList = useAppSelector(state => state.project.entities);
  const workTypeList = useAppSelector(state => state.common.workType);
  const employeeList = useAppSelector(state => state.common.orgsForm);
  const fieldList = useAppSelector(state => state.field.entities);
  const updating = useAppSelector(state => state.objective.updating);
  const filters = useAppSelector(state => state.filters.objective);
  const updateSuccess = useAppSelector(state => state.objective.updateSuccess);
  const [isOpenModal, setOpenModal] = useState(false);
  const [alignSelected, setAlignmentSelected] = useState([]);
  const [formData, setFormData] = useState(null);

  const handleClose = (idObjective = undefined) => {
    form.resetFields();
    onClose(updateSuccess, idObjective);
  };

  useEffect(() => {
    innitData();
  }, [isOpen]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (objectiveEntity && !isNew) {
      setAlignmentSelected(objectiveEntity?.associateIds);
      setFormData({
        ...objectiveEntity,
        contribution: objectiveEntity.contribution && displayPercent(objectiveEntity.contribution),
      });
      form.setFieldsValue({
        ...objectiveEntity,
        contribution: objectiveEntity.contribution && displayPercent(objectiveEntity.contribution),
      });
    }
  }, [objectiveEntity]);

  const innitData = () => {
    // get detail
    dispatch(getAssociates());
    dispatch(getFields({}));
    dispatch(getEmployees());
    dispatch(getBoxWorkType());
    dispatch(getPlanPeriods({}));
    dispatch(getProjects({}));
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getEntity(id));
    }
  };

  // eslint-disable-next-line complexity
  const handleSubmit = () => {
    const oldEntity = !isNew ? objectiveEntity : undefined;
    const entity = {
      ...oldEntity,
      ...formData,
      contribution: percent(formData.contribution),
      tags: _.split(formData.tags, ','),
      planTags: _.split(formData.planTags, ','),
      informEmails: _.split(formData.informEmails, ','),
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleSubmitAndNavigateCreateKr = () => {
    form
      .validateFields()
      .then(async values => {
        const oldEntity = !isNew ? objectiveEntity : undefined;
        const entity = {
          ...oldEntity,
          ...formData,
          contribution: percent(formData.contribution),
          tags: _.split(formData.tags, ','),
          planTags: _.split(formData.planTags, ','),
          informEmails: _.split(formData.informEmails, ','),
        };
        const response = await dispatch(createEntityWithOpenModalKr(entity));
        if (response && response.payload) {
          const result = response.payload as any;
          handleClose(result.data);
        }
      }).catch(() => {
        return;
      })
  };

  const handleFormChange = (changedValues, allValues) => {
    if (changedValues.accountableId) {
      const employee = _.find(employeeList, o => {
        return o.id === changedValues.accountableId;
      });
      if (employee) {
        setFormData({
          ...allValues,
          accountableOrganizationId: employee.partyId,
        });
        return;
      }
    }
    setFormData({ ...formData, ...allValues });
  };

  const handleCloseModal = (isUpdateValue = true, itemSelected = []) => {
    if (isUpdateValue) {
      setFormData({ ...formData, associateIds: itemSelected.map(x => x.id) });
      form.setFieldValue('alignCode', itemSelected.length > 0 ? `${_.join(itemSelected.map(x => x.code), " ,")}` : null);
    }
    setOpenModal(false)
  }

  const handleOpenModalViewRowSelection = () => {
    setOpenModal(true)
  }

  return (
    <Modal
      open={isOpen}
      maskClosable={false}
      onCancel={() => {
        onClose();
      }}
      footer={null}
      width={1300}
    >
      <Container className="form">
        <Form size="large" onValuesChange={handleFormChange} form={form} onFinish={handleSubmit} layout="vertical">
          <Title level={3}>{`${id ? 'Cập nhật thông tin' : 'Thêm mới'} mục tiêu`}</Title>
          <Row>
            <Col md={5}>
              <Form.Item label="Bên nhận mục tiêu" rules={[{ required: true, message: 'Hãy chọn bên nhận mục tiêu' }]} name="accountableId">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={employeeList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn bên nhận mục tiêu"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Form.Item label="Kỳ kế hoạch" rules={[{ required: true, message: 'Hãy chọn kỳ kế hoạch' }]} name="planPeriodId">
                <Select
                  allowClear
                  showSearch
                  size="large"
                  filterOption={filterOption}
                  options={_.filter(planPeriodList, o => {
                    return o.planPeriodType === PlantPeriodType.Year;
                  }).map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn kỳ kế hoạch"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item
                label="Mục tiêu, KR liên kết"
                name={'alignCode'}
              >
                <Row gutter={8} align="middle">
                  <Col flex="auto">
                    <Form.Item noStyle
                      name={'alignCode'}>
                      <Input
                        readOnly
                        size="large"
                        placeholder="Chọn mục tiêu, KR liên kết"
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Button
                      className="primary"
                      size="large"
                      onClick={handleOpenModalViewRowSelection}
                      icon={<PlusOutlined />}
                    >
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <Form.Item label="Lĩnh vực" name="field">
                <Select
                  allowClear
                  showSearch
                  size="large"
                  filterOption={filterOption}
                  options={fieldList.map(x => {
                    return {
                      label: x.description,
                      value: x.value,
                    };
                  })}
                  placeholder="Chọn lĩnh vực"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Form.Item label="Dự án" name="projectId">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={projectList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn dự án"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={5}>
              <Form.Item label="Mảng công việc" name="workTypeId">
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  size="large"
                  options={workTypeList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                  placeholder="Chọn mảng công việc"
                />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={6}>
              <Form.Item label="Phân quyền truy cập" name={'accessIds'}>
                <Select
                  filterOption={filterOption}
                  allowClear
                  showSearch
                  mode='multiple'
                  size="large"
                  options={employeeList.map(x => {
                    return {
                      label: x.name,
                      value: x.id,
                    };
                  })}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Nội dung mục tiêu" rules={[{ required: true, message: 'Hãy nhập nội dung mục tiêu' }]} name={'purpose'}>
                <TextArea
                  placeholder="Là một cụm từ phản ánh phương hướng, định hướng, kết quả mong muốn về một vấn đề cụ thể cần đạt được trong kỳ kế hoạch"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>

            <Col md={24}>
              <Form.Item label="Người nhận thông báo (cách nhau dấu phẩy)" name={'informEmails'}>
                <Input className="w-100" placeholder="Nhập người nhận thông báo" size="large" />
              </Form.Item>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Col>
          </Row>
          <Row>
            <Col md={11}>
              <Form.Item label="Tag" name={'tags'}>
                <Input className="w-100" size="large" placeholder="Nhập tag" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item label="Plan tag" name={'planTags'}>
                <Input className="w-100" size="large" placeholder="Nhập plan tag" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Row className="action mt-3" justify="end">
              {isNew && (
                <Col>
                  <Button className="green" onClick={handleSubmitAndNavigateCreateKr} disabled={updating}>
                    Lưu & Tạo KR
                  </Button>
                </Col>
              )}
              <Col>
                <Button className="primary" htmlType="submit" disabled={updating}>
                  Lưu
                </Button>
              </Col>
              <Col>
                <Button
                  className="secondary"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Hủy
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
        {isOpenModal &&
          <ObjectiveKRRowSelection defaultSelected={alignSelected} isOpen={isOpenModal} onClose={handleCloseModal} />
        }
      </Container>
    </Modal>
  );
};

export default ObjectiveUpdate;
